import { getRequest } from '@/core';
import { savedTripSearches } from '@/requests';

export default async function getSavedTripSearchCountRequest(id) {
	let url = savedTripSearches.getCountByIdPath(id);
	let response = await getRequest(url);
	return response;
}
